module.exports = __webpack_public_path__ + "img/eex.ee7f4712.svg";